const verifyFeatureTester = {
  data() {
    return {
      activeFeatureTags: [],
    }
  },

  computed: {
    isOnlyPlp() {
      const { activeFeatureTags } = this;
      return !activeFeatureTags.includes('ptl-correios-ppn');
    },

    isJadlogIndustrialTester() {
      const {activeFeatureTags} = this;

      return activeFeatureTags.includes('ptl-jadlog-centralized');
    }
  },

  methods: {
    /**
     * Get user's information.
     *
     * It's mandatory to declare 'this.userID' inside your
     * component's data.
     *
     */
    async loadUserData() {
      try {
        const {data: {id}} = await axios.get('/api/v2/me/');

        this.userID = id
      } catch (error) {
        console.error(error)
      }
    },

    /**
     * Returns if the current user has the passed feature test tag.
     *
     * @param {String} user - ID of the user.
     * @param {String} feature - Feature test tag to be verified.
     */
    async verifyFeatureTester(user, feature) {
      try {
        const {
          data: {isUserTester}
        } = await axios.get(`/api/v2/feature-tester/${user}/${feature}`)

        if (isUserTester) {
          this.activeFeatureTags.push(feature);
        }
      } catch (error) {
        console.error(error)
      }
    },
  }
}

export default verifyFeatureTester;
